import React from 'react'
import Header from './Header'; 
import Heros from "./Heros";
import Teachers from  "./Teachers"
import Studends from "./Studends";
import Footer from "./Footer"
import UserDoctorsPanel from './UserDoctorsPanel';
import Courses from '../user/Courses';

const Home = () => {
  return (
    <>
      <Header />
      <Heros/>
      <Courses />
      <Teachers />
      <Studends />
      <UserDoctorsPanel/>
      <Footer/>
    </>
  )
}

export default Home;